const host = process.env.REACT_APP_BACKEND_URL
const host2 = process.env.REACT_APP_BACKEND_URL
export const url = `${host}/`
export const url2 = `${host2}/`
